import {normalizeAiPromo} from '../../../utils/aiMatch/normalizeAiPromo';

const initialState = {
  lobbyId: null,
  creatorId: null,
  // Статус лобби на сервере ('preparation', 'game_started', ...). null —
  // старый сервер его не прислал
  status: null,
  isRanked: false,
  // Ежедневный матч против ИИ (см. utils/aiPromo): лобби целиком ведет сервер
  isAiMatch: false,
  // Расписание и отсчет ИИ-лобби в одном виде (normalizeAiPromo) — только
  // при isAiMatch, иначе null
  aiPromo: null,
  // Чат ИИ-матча: на паузе, пока модератор недоступен (сервер присылает
  // только для isAiMatch; у прочих лобби всегда не на паузе)
  chat: {isPaused: false},
  rankMatchStartAt: null,
  // Пока фаза банов идет — метка времени сервера, когда она истечет (см.
  // configs/factionBans.js). Итог фазы едет в самих игроках (bannedFactionId)
  factionBanDeadlineAt: null,
  // Голоса фазы банов — только у участников лобби и только пока фаза идет
  // (в общий список лобби сервер их не кладет): {votesByVoterId:
  // {[голосующий]: {[цель]: фракция}}, confirmedVoterIds, voterIds}, вне
  // фазы — null (см. utils/lobby/factionBans.js)
  factionBan: null,
  // Окно выбора фракции рейтингового лобби (после банов, до автостарта): id
  // готовых к старту — живой выбрал фракцию и подтвердил выбор, бот и ИИ
  // просто выбрали (см. utils/lobby/rankFactionConfirm.js). Сам выбор
  // соперника до старта тайна — сервер присылает только готовность. Вне окна
  // и у обычных лобби — пустой список
  factionSelectReadyIds: [],
  players: [],
  // Зрители матча ({id, name, status}) — их число показывает боковая панель
  // списка игроков. Гостей-зрителей сервер в дескриптор не кладет вовсе
  spectators: [],
  selectedFieldId: null,
  // Бонус обычного лобби на всех игроков (см. utils/lobby/lobbyBonus)
  bonusType: 'none',
};

/**
 * Поля дескриптора лобби (getLobbyDescriptor на сервере), которые хранит
 * клиент. SET_LOBBY (ответ на вход) и LOBBY_UPDATE (рассылка) несут один и
 * тот же дескриптор — раньше каждый перечислял поля сам, и новое поле легко
 * было добавить только в один из них. Значения по умолчанию — для старого
 * сервера, который поле еще не присылает: отсутствие поля значит «нет».
 */
export const pickLobbyDescriptorFields = (payload = {}) => {
  const isAiMatch = Boolean(payload.isAiMatch);
  return {
    lobbyId: payload.lobbyId,
    lobbyName: payload.lobbyName,
    creatorId: payload.creatorId,
    status: payload.status || null,
    isRanked: payload.isRanked || false,
    isAiMatch,
    aiPromo: isAiMatch ? normalizeAiPromo(payload.aiPromo) : null,
    chat: {isPaused: isAiMatch && Boolean(payload.chat?.isPaused)},
    rankMatchStartAt: payload.rankMatchStartAt || null,
    factionBanDeadlineAt: payload.factionBanDeadlineAt || null,
    factionBan: payload.factionBan || null,
    factionSelectReadyIds: Array.isArray(payload.factionSelectReadyIds) ? payload.factionSelectReadyIds : [],
    players: payload.players || [],
    spectators: payload.spectators || [],
    selectedFieldId: payload.selectedFieldId || null,
    bonusType: payload.bonusType || 'none',
  };
};

const lobbyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOBBY':
    case 'LOBBY_UPDATE':
      return {
        ...state,
        ...pickLobbyDescriptorFields(action.payload),
      };
    case 'LEAVE_LOBBY':
      return initialState;
    default:
      return state;
  }
};

export default lobbyReducer;
